__turbopack_context__.v({
  "benefits": "PlasmicHomeBenefitsSection-module__VEK0BG__benefits",
  "col6": "PlasmicHomeBenefitsSection-module__VEK0BG__col6",
  "freeBox": "PlasmicHomeBenefitsSection-module__VEK0BG__freeBox",
  "role": "PlasmicHomeBenefitsSection-module__VEK0BG__role",
  "roleDropdown": "PlasmicHomeBenefitsSection-module__VEK0BG__roleDropdown",
  "sectionHeader": "PlasmicHomeBenefitsSection-module__VEK0BG__sectionHeader",
  "tagline": "PlasmicHomeBenefitsSection-module__VEK0BG__tagline",
  "top6": "PlasmicHomeBenefitsSection-module__VEK0BG__top6",
  "wrapper5": "PlasmicHomeBenefitsSection-module__VEK0BG__wrapper5",
});
